module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-litho-finish-limestone-oyster.a50e7f85.jpg";